<template>
  <el-row v-if="userCard" v-loading="loadingUser" :gutter="24">
    <el-col :xs="24">

      <div class="user-info">
        <div class="user-info__content">
          <div class="field">
            <div class="field__title">Статус:</div>
            <div class="field__input">
              <el-select
                  v-model="userCard.status"
                  class="user-info__select"
                  placeholder="Выберите"
                  @change="saveUserCard()">
                <el-option
                    v-for="item in userInfoList.status"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="field">
            <div class="field__title">Скидка:</div>
            <div class="field__input">
              <el-select
                  v-model="userCard.discount"
                  class="user-info__select"
                  placeholder="Выберите"
                  @change="saveUserCard()">
                <el-option
                    v-for="item in userInfoList.discount"
                    :key="item.id"
                    :label="item.title"

                    :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="user-info__content">
          <div class="field-class field">
            <div class="field-class__name">
              <div class="field__title">Класс:</div>
              <div class="field__input">
                <el-select
                    v-model="userCard.class"
                    class="user-info__select"
                    placeholder="Последние"
                    @change="saveUserCard()">
                  <el-option
                      v-for="item in userInfoList.class"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="field-class__number">
              <div class="field__title">№ в классе:</div>
              <div class="field__input">
                <el-select v-model="userCard.class_position"
                           class="user-info__select"
                           placeholder="Выберите..."
                           @change="saveUserCard()">
                  <el-option
                      v-for="item in userInfoList.class_position"
                      :key="item.id"

                      :label="item.title"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="field">
            <div class="field__title">Источник:</div>
            <div class="field__input">
              <el-select
                  v-model="userCard.source"
                  class="user-info__select"
                  placeholder="Введите ..."
                  @change="saveUserCard()">
                <el-option
                    v-for="item in userInfoList.source"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

        </div>

        <div class="user-info__content">
          <div class="field">
            <div class="field__title">Комментарий:</div>
            <div class="field__input">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 8}"
                  v-model="userCard.comment"
                  placeholder="Введите комментарий..."
                  @change="saveUserCard()"></el-input>
            </div>
          </div>
          <div class="field"></div>
        </div>


      </div>
    </el-col>
  </el-row>

</template>

<script>
export default {
  name: "UserSettingsPanel",
  data() {
    return {
      loadingUser: true,
      userCard: {},
      userInfoList: [],
    }
  },
  props: {
    user: {
      required: true
    }
  },
  watch: {
    user() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getUserInfoList();

      this.userCard = {
        discount: this.user.discount ? this.user.discount.id : null,
        status: this.user.status ? this.user.status.id : null,
        source: this.user.source ? this.user.source.id : null,
        class: this.user.class ? this.user.class.id : null,
        class_position: this.user.class_position ? this.user.class_position.id : null,
        comment: this.user.comment ? this.user.comment : null,
      }
    },
    saveUserCard() {
      this.loadingUser = true;
      this.$api.user.update(this.userCard, this.user.id)
          .then(() => {

            this.$notify.success({
              title: "Удачно...",
              message: "Запись изменена",
            });

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка изменения 😕",
              message: response.response.data.message,
            });

          })
          .finally(() => {
            this.loadingUser = false;
          });
    },
    getUserInfoList() {
      this.loadingUser = true;
      this.$api.user.getInfoList()
          .then((response) => {

            for (let el in response.data) {
              response.data[el].push({id: null, title: "-"})
            }
            this.userInfoList = response.data

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки полей пользователя 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loadingUser = false;
          })
    },
  }
}

</script>

<style lang="scss" scoped>
.user-info {
  margin-top: 24px;

  font-size: 13px;
  line-height: 16px;
  color: #111;

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  &__select {
    width: 100%;
  }

}

.field {
  width: 50%;

  &__title {
    margin: 8px 0;
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;

    color: #606266;
  }
}

.field-class {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__name {

  }

  &__number {
    width: 110px;
  }
}
</style>
